import { render, staticRenderFns } from "./IconPaperAirplaneOutline.vue?vue&type=template&id=c0294460"
import script from "./IconPaperAirplaneOutline.vue?vue&type=script&lang=js"
export * from "./IconPaperAirplaneOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports